import { Container, Box } from "@mui/material";
import Loader from "../Loader";

// TODO: Use this Page component on every page as a root component
const Page = ({ label, loading, children, sx = {} }) => {
  return (
    <>
      {loading ? (
        <Loader boxMinHeight="550px" />
      ) : (
        <Container
          sx={{
            minHeight: "550px",
            mb: 10,
            mt: 3,
            display: "flex",
            alignItems: "flex-start",
            ...sx,
          }}
        >
          <Box sx={{ width: "100%" }}>
            {label && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <h1>{label}</h1>
              </Box>
            )}
            {children}
          </Box>
        </Container>
      )}
    </>
  );
};

export default Page;
